var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrowRight03D = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#999",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.666 2.667 12 8l-5.334 5.333 1.32 1.32L14.64 8 7.986 1.347z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.334 2.667 6.667 8l-5.333 5.333 1.32 1.32L9.307 8 2.654 1.347z"
}))));
export default SvgIconArrowRight03D;